import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

const LightMode = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,

      primary: {
        main: '#f56a00',
      },
      secondary: {
        main: '#0057b8',
      },

      error: {
        main: '#d32f2f',
      },
      warning: {
        main: '#ff2500',
      },
      info: {
        main: '#ffad08',
      },
      success: {
        main: '#388e3c',
      },

      background: {
        default: '#FFFFFF',
        paper: '#F5F5F5',
      },

      text: {
        primary: '#1F2326',
        secondary: '#2C2F33',
      },

      divider: '#E0E0E0',

      banner: {
        info: '#0288d1',
        error: '#d32f2f',
        warning: '#FFB74D',
        text: '#1F2326',
        link: '#0057b8',
      },
      errorBackground: '#f44336',
      warningBackground: '#FFF3E0',
      infoBackground: '#E3F2FD',

      navigation: {
        background: '#F5F5F5',
        indicator: '#f56a00',
        color: '#1F2326',
        selectedColor: '#f56a00',
        hoverBackground: 'rgba(245, 90, 0, 0.1)',
        hoverColor: '#1F2326', 
        activeBackground: 'rgba(245, 90, 0, 0.2)',
        activeColor: '#1F2326',
        subtitleColor: '#2C2F33',
        buttonPosition: 'below',
      },
    },
  }),

  defaultPageTheme: 'home',

  fontFamily: 'Arial, sans-serif',

  pageTheme: {
    home: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: ['#1F2326', '#999999'],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: ['#1F2326', '#999999'], 
      shape: shapes.wave,
    }),
  },
});

export default LightMode;
